import { Navigate, useParams } from 'react-router-dom';

export default function ViewsList() {
  const { projectId } = useParams<{ projectId: string }>();
  if (!projectId) {
    return <div className="p-6 text-sm text-muted-foreground">Missing stream.</div>;
  }
  return <Navigate to={`/projects/${projectId}/tasks`} replace />;
}
